import { Box, Typography, Container, SxProps, Theme } from "@mui/material";

export const Hero = () => {
  return (
    <Box sx={heroSx}>
      <Container maxWidth="lg">
        <Box sx={heroContentSx}>
          <Typography variant="h1" sx={heroTitleSx}>
            <Typography sx={heroTitleHeadSx} display="inline" variant="inherit">
              A
            </Typography>
            dvanced Managed Service Provider (AMSP)
          </Typography>
          <Typography variant="h2" sx={heroSubtitleSx}>
            副業×ハイエンド×生成AIで肩代わりする運用支援
          </Typography>
          <Typography variant="body1" sx={heroDescriptionSx}>
            クラウド運用の常識を覆す、次世代マネージドサービスプロバイダー。従来の枠を超えた包括的なクラウド運用サポートで、お客様のビジネス成長を加速させます。
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const heroSx: SxProps<Theme> = (theme) => ({
  width: "100%",
  background: "rgba(34, 161, 185, 0.1)",
  padding: "60px 0 92px",
  textAlign: "center",
  position: "relative",
  overflow: "hidden",
});

const heroContentSx: SxProps<Theme> = {
  position: "relative",
  zIndex: 2,
};

const heroTitleSx: SxProps<Theme> = (theme) => ({
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "Avenir Next",
  fontWeight: 500,
  fontSize: {
    md: "64px",
    xs: "40px",
  },
  padding: "20px 0",
  // lineHeight: "88px",
  // letterSpacing: "0.15em",
});

const heroTitleHeadSx: SxProps<Theme> = (theme) => ({
  color: "#22A1B9",
  fontWeight: 700,
});

const heroSubtitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "1.4rem",
  marginBottom: "15px",
  color: "#22A1B9",
  fontWeight: 600,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.2rem",
  },
});

const heroDescriptionSx: SxProps<Theme> = {
  fontSize: "1.1rem",
  marginBottom: "30px",
  opacity: 0.9,
  maxWidth: "700px",
  marginLeft: "auto",
  marginRight: "auto",
};
